import { GraphQLError } from 'graphql';
import React, { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';

import { ErrorState, ErrorType } from '@sbu/components.errorstate';
import { Button } from '@sumologic/yama-ds-components';

import { isGraphQLNotFoundError } from 'shared/components/utils/ErrorBoundary';

export interface ErrorProps {
  children?: ReactNode;
  graphQLError?: ReadonlyArray<GraphQLError>;
  type?: ErrorType | undefined;
  skipErrorLogging?: boolean;
}

export const Error = ({
  children,
  graphQLError,
  type,
  skipErrorLogging = false,
}: ErrorProps) => {
  const history = useHistory();

  const isAccessedDirectly = !history?.length || history.length <= 2;

  const handleClick = () => {
    isAccessedDirectly ? history.push('/') : history.goBack();
  };

  const errorType =
    type ?? (isGraphQLNotFoundError(graphQLError?.[0]) ? 'notFound' : 'server');

  // Pass the GraphQLError to ErrorState for better Sentry stack traces
  // GraphQLError extends Error so it has a proper stack trace
  const error = graphQLError?.[0] as Error | undefined;

  return (
    <ErrorState
      type={errorType}
      error={error}
      skipErrorLogging={skipErrorLogging}
    >
      {children}
      {errorType !== 'client' && (
        <Button onClick={handleClick}>
          {isAccessedDirectly ? 'Go Home' : 'Back to Previous Page'}
        </Button>
      )}
    </ErrorState>
  );
};

export default Error;
